import { z } from 'zod';
export type ProfileMenuEventType =
  | 'ProfileMenu_LanguageChange'
  | 'ProfileMenu_ViewChange'
  | 'ProfileMenu_LogoutClick'
  | 'ProfileMenu_AccountDetailsClick'
  | 'ProfileMenu_CopyIDClick'
  | 'ProfileMenu_MenuOpen'
  | 'ProfileMenu_MenuClose';

// Profile menu event payload schemas
export const ProfileMenuEventBaseSchema = z.object({
  url: z.string(),
});

export const ProfileMenu_LanguageChangePayloadSchema = ProfileMenuEventBaseSchema.extend({
  language: z.string(),
});

export const ProfileMenu_ViewChangePayloadSchema = ProfileMenuEventBaseSchema.extend({
  previousView: z.string(),
  nextView: z.string(),
});

export const ProfileMenu_LogoutClickPayloadSchema = ProfileMenuEventBaseSchema;

export const ProfileMenu_AccountDetailsClickPayloadSchema = ProfileMenuEventBaseSchema;
export const ProfileMenu_MenuOpenPayloadSchema = ProfileMenuEventBaseSchema;
export const ProfileMenu_MenuClosePayloadSchema = ProfileMenuEventBaseSchema;
export const ProfileMenu_CopyIDClickPayloadSchema = ProfileMenuEventBaseSchema;
export type ProfileMenuEventTypePayloadMap = {
  ProfileMenu_LanguageChange: z.infer<typeof ProfileMenu_LanguageChangePayloadSchema>;
  ProfileMenu_ViewChange: z.infer<typeof ProfileMenu_ViewChangePayloadSchema>;
  ProfileMenu_LogoutClick: z.infer<typeof ProfileMenu_LogoutClickPayloadSchema>;
  ProfileMenu_AccountDetailsClick: z.infer<typeof ProfileMenu_AccountDetailsClickPayloadSchema>;
  ProfileMenu_CopyIDClick: z.infer<typeof ProfileMenu_CopyIDClickPayloadSchema>;
  ProfileMenu_MenuOpen: z.infer<typeof ProfileMenu_MenuOpenPayloadSchema>;
  ProfileMenu_MenuClose: z.infer<typeof ProfileMenu_MenuClosePayloadSchema>;
};

export const ProfileMenuEventSchemaMap = {
  ProfileMenu_LanguageChange: ProfileMenu_LanguageChangePayloadSchema,
  ProfileMenu_ViewChange: ProfileMenu_ViewChangePayloadSchema,
  ProfileMenu_LogoutClick: ProfileMenu_LogoutClickPayloadSchema,
  ProfileMenu_AccountDetailsClick: ProfileMenu_AccountDetailsClickPayloadSchema,
  ProfileMenu_CopyIDClick: ProfileMenu_CopyIDClickPayloadSchema,
  ProfileMenu_MenuOpen: ProfileMenu_MenuOpenPayloadSchema,
  ProfileMenu_MenuClose: ProfileMenu_MenuClosePayloadSchema,
};
